var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedrequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_96621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 43.9558L21.3095 46.7105C20.6863 44.9958 20.3463 43.1463 20.3463 41.2168C20.3463 36.7726 22.1484 32.7474 25.0611 29.8347C27.9726 26.9232 31.9979 25.121 36.4421 25.121C40.8863 25.121 44.9116 26.9232 47.8242 29.8347C48.4383 30.4501 49.0022 31.1136 49.5105 31.8189L49.6568 4.30421L18.0916 0L0 8.20842V43.9558Z",
    fill: "#C28F60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6568 4.30421L48.3968 5.12526L35.681 13.0579L0 8.20842L18.0916 0L49.6568 4.30421Z",
    fill: "#AA7950"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8115 25.1326V13.2631L49.6568 4.3042L49.9999 32.5368C49.3726 31.5589 48.642 30.6537 47.8242 29.8347C44.9115 26.9231 40.8863 25.121 36.4421 25.121C36.2315 25.121 36.021 25.1253 35.8115 25.1326Z",
    fill: "#D2A06D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4338 0.864258L34.7738 2.27478L19.9738 11.119L19.9644 26.4264L14.698 22.839L9.43066 25.8158L10.0886 9.74426L24.4338 0.864258Z",
    fill: "#65472F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4419 28.5126C43.4588 28.5126 49.1461 34.1999 49.1461 41.2168C49.1461 48.2326 43.4588 53.9199 36.4419 53.9199C29.4261 53.9199 23.7388 48.2326 23.7388 41.2168C23.7388 34.1999 29.4261 28.5126 36.4419 28.5126Z",
    fill: "#3AAF3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1558 35.62H44.1095C40.0463 40.1326 36.8968 43.8526 34.0768 49.2926C32.6084 46.1537 31.2989 43.9863 28.3716 41.9768L29.4642 41.7305C31.6526 43.52 32.8053 45.5095 34.0768 48.2284C36.6716 43.221 39.5474 39.6716 43.1558 35.62Z",
    fill: "#0DA10D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5811 40.1874C32.5568 40.7495 33.1926 41.2168 33.9484 42.0505C35.9105 38.8926 38.04 37.1432 40.8084 34.66L41.0789 34.5558H44.1095C40.0463 39.0674 36.8968 42.7884 34.0768 48.2284C32.6084 45.0895 31.2989 42.9221 28.3716 40.9126L31.5811 40.1874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_96621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 53.92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedrequestIcon);
export default __webpack_public_path__ + "static/media/approvedrequestIcon.fcbdbb2b0f302172098fa6bf36d76fd5.svg";
export { ForwardRef as ReactComponent };